import { TitledDialog } from "../TitledDialog";
import { html } from "lit-html";
import { translate } from "../../../shared/l10n/translate";
import { trackPageOnce } from "../../tracker/EventTracker";
import {
	PROFILE_GALLERY,
	PROFILE_GALLERY_THUMBNAILS,
} from "@escapio/shared/components/picture-sizes";
import "../PictureGallery";
import "../Zoomable";

export class GalleryDialog extends TitledDialog {
	constructor(hotel, eventCategory) {
		super();
		this.hotel = hotel;
		this.eventCategory = eventCategory;
		this.initialPicture = 0;
		this.node.classList.add("dialog--gallery", "dialog--transparent-header");
		this.keyHandler = this.onKeyDown.bind(this);
		this.wheelHandler = this.onWheel.bind(this);
		this.titleText = hotel.name;
		this.subtitleText = `${hotel.street}, ${hotel.zip} ${hotel.city_name}, ${hotel.region_name}, ${hotel.country_name}`;
		this.closeButtonText = translate("hotel_close_gallery");
	}

	show(initialPicture) {
		this.currentPicture = parseInt(initialPicture);
		super.show();
		document.addEventListener("keydown", this.keyHandler);
		document.body.classList.add("dialog--open");
		this.node.addEventListener("wheel", this.wheelHandler);
	}

	hide() {
		this.node.removeEventListener("wheel", this.wheelHandler);
		document.body.classList.remove("dialog--open");
		document.removeEventListener("keydown", this.keyHandler);
		super.hide();
	}

	render() {
		super.render();
		this.bigPicture = this.node.querySelector(".dialog__gallery-big-picture");
		this.thumbnails = this.node.querySelector(".dialog__gallery-thumbnails");
	}

	renderBigPicture(idx, { filename, alt }) {
		return html`
			<esc-zoomable
				class="picture-gallery__image"
				event-category="${this.eventCategory}"
				event-action="Galerie Zoom"
			>
				<esc-picture
					alt=${alt}
					sizes-key="${PROFILE_GALLERY}"
					filename="${filename}"
				></esc-picture>
			</esc-zoomable>
		`;
	}

	getTemplateHeaderMiddle() {
		return html`<i class="fa fa-camera"></i> ${this.currentPicture + 1} /
			${this.hotel.pictures.length}`;
	}

	getTemplateContent() {
		return html`
			<esc-picture-gallery
				class="dialog__gallery-big-picture"
				track-category="${this.eventCategory}"
				track-action-prefix="Galerie "
				enable-arrows
				enable-loader
				enable-counter
				force-load
				.pictures=${this.hotel.pictures}
				.currentPicture=${this.currentPicture}
				.currentDelta=${this.currentDelta}
				.customRenderPicture=${this.renderBigPicture.bind(this)}
				.beforeOverlay=${html` <header class="dialog__transparent-header">
					<div class="dialog__transparent-header__text">
						<h2 class="dialog__transparent-header__title ellipsis">
							${this.titleText}
						</h2>
						<h2 class="dialog__transparent-header__subtitle ellipsis">
							${this.subtitleText}
						</h2>
					</div>
				</header>`}
				.afterOverlay=${html` <div class="dialog__transparent-header__button">
					<button @click=${this.hide.bind(this)}>
						<span
							class="close-icon close-icon--large close-icon--with-hover"
						></span>
					</button>
				</div>`}
				@PictureChanged=${this.render}
			></esc-picture-gallery>
			<div class="dialog__gallery-bottom">
				<esc-picture-gallery
					sizes-key="${PROFILE_GALLERY_THUMBNAILS}"
					class="dialog__gallery-thumbnails"
					track-category="${this.eventCategory}"
					track-action-prefix="Thumbnails "
					track-all-swipes
					visible-pictures="21"
					preloaded-pictures="2"
					picture-width="mobile:60,desktop:100"
					picture-margin="4"
					force-load
					.pictures=${this.hotel.pictures}
					.currentPicture=${this.currentPicture}
					.currentDelta=${this.currentDelta}
					@PictureChanged=${this.onThumbnailChange}
				></esc-picture-gallery>
				<div class="dialog__gallery-thumbnail-selected"></div>
			</div>
		`;
	}

	onThumbnailChange({ detail: { currentPicture, currentDelta } }) {
		this.updateBigPicture(currentPicture, currentDelta);
	}

	get currentPicture() {
		return this.bigPicture
			? this.bigPicture.currentPicture
			: this.initialPicture;
	}

	get currentDelta() {
		return this.bigPicture ? this.bigPicture.currentDelta : 0;
	}

	set currentPicture(value) {
		if (this.bigPicture) {
			this.updateBigPicture(value, 0);
		} else {
			this.initialPicture = value;
		}
	}

	updateBigPicture(currentPicture, currentDelta) {
		this.bigPicture.currentPicture = currentPicture;
		this.bigPicture.currentDelta = currentDelta;
		this.render();
	}

	onKeyDown(event) {
		switch (event.key) {
			case "Left":
			case "ArrowLeft":
				event.preventDefault();
				this.bigPicture.goOne("left");
				trackPageOnce(
					this.eventCategory,
					"Galerie Pfeiltasten genutzt",
					"Zurück",
				);
				break;
			case "Right":
			case "ArrowRight":
				event.preventDefault();
				this.bigPicture.goOne("right");
				trackPageOnce(this.eventCategory, "Galerie Pfeiltasten genutzt", "Vor");
				break;
		}
	}

	onWheel(event) {
		event.preventDefault();
		if (event.deltaY < -2) {
			this.bigPicture.goOne("left");
			trackPageOnce(this.eventCategory, "Galerie Mausrad genutzt", "Zurück");
		}
		if (event.deltaY > 2) {
			this.bigPicture.goOne("right");
			trackPageOnce(this.eventCategory, "Galerie Mausrad genutzt", "Vor");
		}
	}
}
